import * as Yup from 'yup';
import moment from 'moment';

const dataNaoFutura = (val) => {
  if (!val) return false;
  return moment(val).startOf('day').isBefore(moment().startOf('day'));
};

// W-0840 — Schema Formik para o CardFiltros da geração de Comissão de Imóveis.
// LICOES §1.6: validação Yup completa (required + tipo + min/max + regra de negócio via .test()/.when()).
// RN-1 (UComissao_Imoveis.pas:181): "Data final não pode ser maior ou igual a hoje." (mensagem literal, Q-07=A).
export const processarComissaoSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .typeError('Selecione um Grupo de Empresa')
    .required('Grupo de Empresa é obrigatório')
    .positive('Grupo de Empresa inválido')
    .integer(),

  modo: Yup.string()
    .oneOf(['UM_CORRETOR', 'TODOS'], 'Modo inválido')
    .required('Modo é obrigatório'),

  codigoConta: Yup.number().when('modo', {
    is: 'UM_CORRETOR',
    then: (schema) =>
      schema
        .typeError('Selecione um corretor')
        .required('Corretor é obrigatório')
        .positive('Corretor inválido')
        .integer(),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),

  dataInicial: Yup.date()
    .typeError('Data Inicial inválida')
    .required('Data Inicial é obrigatória'),

  dataFinal: Yup.date()
    .typeError('Data Final inválida')
    .required('Data Final é obrigatória')
    .test(
      'data-final-menor-hoje',
      // RN-1 literal Delphi UComissao_Imoveis.pas:181 (Q-07=A)
      'Data final não pode ser maior ou igual a hoje.',
      dataNaoFutura
    )
    .when('dataInicial', (dataInicial, schema) =>
      dataInicial
        ? schema.min(
            dataInicial,
            'Data Final deve ser maior ou igual à Data Inicial'
          )
        : schema
    ),

  incluirImoveis: Yup.boolean(),
  incluirPgto: Yup.boolean(),
  incluirSinal: Yup.boolean(),
  incluirExplicativo: Yup.boolean(),
  emitirRecibo: Yup.boolean(),
});

export const valoresIniciais = {
  codigoGrupoEmpresa: '',
  modo: 'UM_CORRETOR',
  codigoConta: '',
  dataInicial: '',
  dataFinal: '',
  incluirImoveis: true,
  incluirPgto: true,
  incluirSinal: true,
  incluirExplicativo: true,
  emitirRecibo: false,
};
